import React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { AppBar, Toolbar } from '@material-ui/core';

const headerCSS = css`{{ symbolProps.appBarProps?.css }}`;

const toolbarCSS = css`{{ symbolProps.toolbarProps?.css }}`;

type AppBarSymbolProps = {
  classes?: Record<string, any>;
  style?: Record<string, any>;
  css?: SerializedStyles;
  className?: string;
  onClick?: (event: MouseEvent | undefined) => void;
  onMouseOver?: (event: MouseEvent | undefined) => void;
  onMouseOut?: (event: MouseEvent | undefined) => void;
  onMouseDown?: (event: MouseEvent | undefined) => void;
  onMouseUp?: (event: MouseEvent | undefined) => void;
  onMouseEnter?: (event: MouseEvent | undefined) => void;
  onMouseLeave?: (event: MouseEvent | undefined) => void;
  onWheel?: (event: MouseEvent | undefined) => void;
  onContextMenu?: (event: MouseEvent | undefined) => void;
  onAuxClick?: (event: MouseEvent | undefined) => void;
  key?: number;
  children?: React.ReactNode;
  appBarProps?: {
    onClick?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseOver?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseOut?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseDown?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseUp?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseEnter?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onMouseLeave?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onWheel?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onContextMenu?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    onAuxClick?: ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void) | undefined;
    classes?: Record<string, any>;
    style?: Record<string, any>;
    css?: SerializedStyles;
    className?: string;
    color?: any;
    position?: any;
  };
  toolbarProps?: {
    classes?: Record<string, any>;
    style?: Record<string, any>;
    css?: SerializedStyles;
    className?: string;
    disableGutters?: boolean;
    variant?: any;
  };
};

export const AppBarSymbol: React.FC<AppBarSymbolProps> = symbolProps => {
  return (
    <AppBar
      classes={symbolProps.appBarProps?.classes}
      style={symbolProps.appBarProps?.style}
      css={symbolProps.appBarProps?.css}
      className={symbolProps.appBarProps?.className}
      onClick={symbolProps.appBarProps?.onClick}
      onMouseOver={symbolProps.appBarProps?.onMouseOver}
      onMouseOut={symbolProps.appBarProps?.onMouseOut}
      onMouseDown={symbolProps.appBarProps?.onMouseDown}
      onMouseUp={symbolProps.appBarProps?.onMouseUp}
      onMouseEnter={symbolProps.appBarProps?.onMouseEnter}
      onMouseLeave={symbolProps.appBarProps?.onMouseLeave}
      onWheel={symbolProps.appBarProps?.onWheel}
      onContextMenu={symbolProps.appBarProps?.onContextMenu}
      onAuxClick={symbolProps.appBarProps?.onAuxClick}
      color={symbolProps.appBarProps?.color}
      position={symbolProps.appBarProps?.position}
    >
      <Toolbar
        classes={symbolProps.toolbarProps?.classes}
        style={symbolProps.toolbarProps?.style}
        css={symbolProps.toolbarProps?.css}
        className={symbolProps.toolbarProps?.className}
        disableGutters={symbolProps.toolbarProps?.disableGutters}
        variant={symbolProps.toolbarProps?.variant}
      >
        {symbolProps.children}
      </Toolbar>
    </AppBar>
  );
};
